import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LinkButton from '../../link-button';

/**
 * Uses the Navigation.location API to retrieve GPS coordinates,
 * then calls Shelter APIs to determine the Local Authority
 */
const GPSSelector = ({ lookup, cancel, inUse = () => {} }) => {
  /**
   * Loading and error states for GPS
   */
  const [isLoading, setLoading] = useState(false);
  const [isError, setError] = useState(false);

  /**
   * GPS Loading
   */
  if (isLoading && !isError) {
    return (
      <>
        <p>Searching, please wait...</p>
        <p>
          <LinkButton
            onClick={() => {
              cancel(true);
              setLoading(false);
            }}
            type="button"
          >
            Use a different way of finding your location
          </LinkButton>
        </p>
      </>
    );
  }

  /**
   * GPS or Local Authority error
   */
  if (isError) {
    return (
      <>
        <p>There was a problem detecting your location</p>
        <LinkButton onClick={() => cancel(true)} type="button">
          Use an alternative method
        </LinkButton>
      </>
    );
  }

  /**
   * Initial State
   */
  return (
    <LinkButton
      bg="secondary-standard"
      type="button"
      onClick={() => {
        inUse();
        setLoading(true);
        navigator.geolocation.getCurrentPosition(
          (p) => {
            const { latitude, longitude } = p.coords;
            lookup({ latitude, longitude });
          },
          (e) => setError(e)
        );
      }}
    >
      Use my GPS location
    </LinkButton>
  );
};

GPSSelector.propTypes = {
  lookup: PropTypes.func.isRequired, // Choose a Local Authority Area
  cancel: PropTypes.func.isRequired, // Cancel GPS, use an alternative method. Send true if error
  inUse: PropTypes.func.isRequired, // Call when GPS is used, to hide alternative methods
};

export default GPSSelector;
